export default interface IContact extends IBaseContact {
    email?: string;
}

export interface IBaseContact {
    phone?: string;
    contactType?: ContactType;
    responsible?: string;
    occupation?: string;
}

export interface ICarriersContact extends IBaseContact, IContact {
    id: string;
    mainContact: boolean;
}

export interface IBranchContact extends IContact {
    id: string;
    mainContact: boolean;
}

export enum ContactType {
    operational = 1,
    commercial = 2,
}
